import { MutationTree } from 'vuex';
import { AppState } from '.';
import {
  SET_CURRENT_WORKSPACE,
  SET_WORKSPACES,
  SET_CURRENT_APP,
  SET_ERROR,
  CLEAR_INSTALLED_APPS,
  ADD_INSTALLED_APP,
  REMOVE_INSTALLED_APP,
} from './mutationTypes';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { PublishedApp } from '@/features/apps/shared/models';

export const mutations: MutationTree<AppState> = {
  [SET_CURRENT_WORKSPACE](state, workspace: WorkspaceViewModel) {
    state.currentWorkspace = workspace;
  },

  [SET_WORKSPACES](state, workspaces: WorkspaceViewModel[]) {
    state.workspaces = workspaces;
  },

  [SET_CURRENT_APP](state, app: PublishedApp) {
    state.currentApp = app;
  },

  [SET_ERROR](state, error: string) {
    state.error = error;
  },

  [ADD_INSTALLED_APP](state, appId: string) {
    if (state.installedApps === null) {
      state.installedApps = [];
    }
    state.installedApps.push(appId);
  },

  [REMOVE_INSTALLED_APP](state, appId: string) {
    if (state.installedApps === null) {
      return;
    }
    state.installedApps = state.installedApps.filter((app) => app !== appId);
  },

  [CLEAR_INSTALLED_APPS](state) {
    state.installedApps = [];
  },
};
